export default "__VITE_ASSET__ChD_gfxe__"